// @ts-strict-ignore
import React from 'react'
import { connect } from 'react-redux'
import { brand } from '../../../redux/app-selectors'
import { Card, Button, Field, Label, Input } from '../../../atoms'
import RichTextBlock from '../../ev-rich-text-block'
import {
  moneyRichTextBlockStyles,
  uswitchRichTextBlockStyles,
} from '../single-column-rich-text/styles'

const Calculator = ({ brand, content, jsonBody, sys, rawName, variant }) => {
  return (
    <div className='Calculator' data-calculator-url={jsonBody.url}>
      {content && (
        <RichTextBlock
          style={brand === 'money' ? moneyRichTextBlockStyles : uswitchRichTextBlockStyles}
          content={content}
        />
      )}
      <Card variant='plum'>
        <form className='inner-card'>
          {jsonBody.fields.map((field, i) => (
            <Field key={i}>
              <Label htmlFor={field.name}>{field.label}</Label>
              <Input
                name={field.name}
                type={field.type ?? 'input'}
                prefix={field.prefix}
                suffix={field.suffix}
                value={field.value}
                format={field.format}
              />
            </Field>
          ))}
          <div className='calculator-field-wrapper'>
            <Button
              dataAction={'calculate'}
              /* eslint-disable camelcase */
              dataClickTracking={{
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'credit-card-calculator',
                contentful_name: rawName,
                contentful_variant: variant,
                additionalProps: { text: 'Calculate' },
              }}
            >
              {jsonBody.buttonText}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  )
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Calculator)
